import { useGetTermsGlobalAccount } from 'services/terms-global-account/useTermsGlobalAccount'
import { notNull } from 'utils'
import { TermsList } from 'components/TermsList'

export function TermsGlobalAccount() {
  const { data } = useGetTermsGlobalAccount()

  const termsData = data?.filter(
    (item) => notNull(item.title) && notNull(item.description) && notNull(item.url),
  )

  return <TermsList termsData={termsData ?? []} />
}
